import { withCompInfo } from '../../core/withCompInfo'
import { FlickrBadgeWidgetDefinition, FlickrBadgeWidgetProps } from './types'

export const props = withCompInfo<FlickrBadgeWidgetProps, FlickrBadgeWidgetDefinition>(['compData'], ({ compData }) => {
	return {
		userId: compData.userId,
		tag: compData.tag,
		imageCount: `${compData.imageCount}`,
		whichImages: compData.whichImages,
		imageSize: compData.imageSize,
		layoutOrientation: compData.layoutOrientation,
	}
})
